export const iconFontAwesomeCommunicationComments = (
	<i className="fa-solid fa-comments"></i>
);
